export default "__VITE_ASSET__BGvi73AO__"